export type GsaRow = {
  id: number
  awardModNo: string
  uei: string
  vendorName: string
  contractOfferNo: string
  sins: string
  baseOrAccessory: string
  manufacturerName: string
  mfrPartNo: string
  vendorPartNo: string
  upc: string
  productName: string
  productDescription: string
  uoi: string
  commercialListPrice: string
  discountToGsaExclIff: string
  discountPriceToGsaExclIff: string
  discountPriceToGsaInclIff: string
  coo: string
  validationClin: string | null
  approvedClin: string | null
}

export type GsaFilters = {
  awardModNo: string
  vendorName: string
  manufacturerName: string
  mfrPartNo: string
  productDescription: string
  contractOfferNo: string
  vendorPartNo: string
  uei: string
  baseOrAccessory: string
  productName: string
}

export type GsaDraft = Omit<GsaRow, 'id'>

export const ALL_GSA_COLUMNS: { key: keyof GsaRow; label: string }[] = [
  { key: 'awardModNo', label: 'Award / Mod No.' },
  { key: 'uei', label: 'UEI' },
  { key: 'vendorName', label: 'Vendor Name' },
  { key: 'contractOfferNo', label: 'Contract / Offer No.' },
  { key: 'sins', label: 'SIN(s)' },
  { key: 'baseOrAccessory', label: 'Base or Accessory' },
  { key: 'manufacturerName', label: 'Manufacturer Name' },
  { key: 'mfrPartNo', label: 'MFR Part No.' },
  { key: 'vendorPartNo', label: 'Vendor Part No.' },
  { key: 'upc', label: 'UPC' },
  { key: 'productName', label: 'Product Name' },
  { key: 'productDescription', label: 'Product Description' },
  { key: 'uoi', label: 'UOI' },
  { key: 'commercialListPrice', label: 'Commercial List Price (CPL)' },
  { key: 'discountToGsaExclIff', label: 'Discount to GSA (Excl. IFF) (%)' },
  { key: 'discountPriceToGsaExclIff', label: 'Discount Price to GSA (Excl. IFF)' },
  { key: 'discountPriceToGsaInclIff', label: 'Discount Price to GSA (Incl. IFF)' },
  { key: 'coo', label: 'COO' },
]

export const NORMALIZED_COLUMNS: { key: keyof GsaRow; label: string }[] = [
  { key: 'discountPriceToGsaInclIff', label: 'Contract Price' },
  { key: 'manufacturerName', label: 'Manufacturer' },
  { key: 'mfrPartNo', label: 'MFR Part No.' },
  { key: 'validationClin', label: 'Internal Validation CLIN (Validation)' },
  { key: 'approvedClin', label: 'Internal Validation CLIN (Approved)' },
]
